import React, { Component } from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Link from "gatsby-link";
import { OutboundLink } from 'gatsby-plugin-google-analytics'

const styles = theme => ({
  card: {
    boxShadow: "0px 0 5px #c5c4c4",
    padding: 20,
    margin: 0,
    borderRadius: 10,
    background: 'white',
    "& .caption": {
      "& .title": {
        fontSize: 22,
        margin: 0,
        fontWeight: 400,
        marginTop: 10,
        color: '#5e880b'
      },
      "& .description": {
        color: '#0b333c',
      },
      "& .footer": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'center',
        "& .price": {
          fontWeight: 1000,
          fontSize: 22,
          color: '#6d6d6d'
        }
      }
    }
  },
  image: {
    display: "block",
    position: "relative",
    "&:before, &:after": {
      position: "absolute",
      "z-index": 1,
      content: "",
      opacity: 0,
      transition: "opacity 0.2s ease-in-out"
    },
    "&:before": {
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(white, 0.7)"
    },
    "& img": {
      display: "block",
      width: "100%"
    }
  },
  buyButton: {
    background: '#da9100',
    padding: '10px 20px',
    borderRadius: 20,
    border: 'none',
    color: 'white',
    boxShadow: '1px 3px 5px #b7b7b7'

  }
});

class ProductCard extends Component {
  render() {
    const { product, classes } = this.props;
    return (
      <figure className={classes.card}>
        <Link className={classes.image}>
          <img src={product.fields && product.fields.thumbnailUrl} />
        </Link>
        <figcaption className="caption">
          <h6 className="title">{product.title}</h6>
          <div className="description">
            <p>{product.excerpt}</p>
          </div>
          <div className="footer">
            <span className="price">{product.fields && product.fields.formattedPrice}</span>
            <OutboundLink className={classes.buyButton} href={product.fields && product.fields.pageUrl} target="_blank">Check It Out</OutboundLink>
          </div>
        </figcaption>
      </figure>
    );
  }
}

ProductCard.propTypes = {
  classes: PropTypes.object.isRequired,
  product: PropTypes.node.isRequired
};

export default injectSheet(styles)(ProductCard);



// WEBPACK FOOTER //
// ./src/components/Product/ProductCard.jsx